import { makeStyles } from '@material-ui/styles'
import FontAwesomeIcon from 'pf9-ui-components/built/components/FontAwesomeIcon'
import React, { useCallback } from 'react'
import Button from 'core/elements/button'
import Modal from 'core/elements/modal'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import { formatDate } from 'utils/misc'

const AlertTitle = ({ alert }) => {
  const classes = useStyles()
  const getSeverityClass = useCallback(() => {
    switch (alert.severity) {
      case 'Critical':
        return classes.iconCritical
      case 'Warning':
        return classes.iconWarning
      case 'Info':
        return classes.iconInfo
      default:
        return classes.iconUnknown
    }
  }, [alert.severity, classes])

  return (
    <div className={classes.titleContainer}>
      <FontAwesomeIcon className={getSeverityClass()}>exclamation-circle</FontAwesomeIcon>
      <Text variant="subtitle1">Alert Title</Text>
    </div>
  )
}

export default function AlertDetailsDialog({ alert, onClose }) {
  const classes = useStyles()
  const getSeverityClass = useCallback(() => {
    switch (alert.severity) {
      case 'Critical':
        return classes.infoLabelCritical
      case 'Warning':
        return classes.infoLabelWarning
      case 'Info':
        return classes.infoLabelInfo
      default:
        return classes.infoLabelUnknown
    }
  }, [alert.severity, classes])

  return (
    <Modal
      panel="dialog"
      title={<AlertTitle alert={alert} />}
      onClose={onClose}
      open
      footer={
        <>
          <Button variant="secondary" onClick={onClose} icon="trash-alt">
            Delete Alert
          </Button>
          <Button variant="secondary" onClick={onClose}>
            Close
          </Button>
        </>
      }
    >
      <div className={classes.detailsContainer}>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Severity:</Text>
          <Text variant="caption1" className={getSeverityClass()}>
            {alert.severity}
          </Text>
        </div>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Timestamp:</Text>
          <Text variant="body2">{formatDate(alert.timestamp)}</Text>
        </div>
        <div className={classes.infoContainer}>
          <Text variant="caption1">Description:</Text>
          <Text variant="body2">
            Some detailed description about the alert that could be long or short
          </Text>
        </div>
      </div>
      <div className={classes.infoContainer}>
        <Text variant="caption1">How To Resolve:</Text>
        <Text variant="body2">
          Tell the user how this issue can be resolved by clicking on the button below. The button
          below should perform some action or redirect the user to a page where they can resolve the
          issue.
        </Text>
      </div>
      <div className={classes.actionsContainer}>
        <Button variant="primary" onClick={onClose} icon="wrench">
          Some Action To Resolve Issue
        </Button>
      </div>
      <div className={classes.actionsContainer}></div>
    </Modal>
  )
}

const useStyles = makeStyles<Theme>((theme) => ({
  titleContainer: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gap: theme.spacing(2),
    alignItems: 'center',
  },
  iconCritical: {
    color: theme.components.badge.error.color,
  },
  iconWarning: {
    color: theme.components.badge.warning.color,
  },
  iconInfo: {
    color: theme.components.badge.secondary.color,
  },
  iconUnknown: {
    color: theme.components.badge.unknown.color,
  },
  infoContainer: {
    display: 'grid',
    gridTemplateColumns: 'max-content 1fr',
    gap: theme.spacing(1),
  },
  infoLabelCritical: {
    color: theme.components.badge.error.color,
  },
  infoLabelWarning: {
    color: theme.components.badge.warning.color,
  },
  infoLabelInfo: {
    color: theme.components.badge.secondary.color,
  },
  infoLabelUnknown: {
    color: theme.components.badge.unknown.color,
  },
  detailsContainer: {
    display: 'grid',
    gap: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  actionsContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(2),
  },
}))
